var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-table',{ref:"taskList",attrs:{"model":_vm.model,"endpoint":_vm.endpoint,"route-context":_vm.$route.meta?.context},on:{"action":_vm.doAction,"bulkAction":_vm.doBulkAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }